import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import InternalContainer from 'components/internal-container/internal-container';

export const MvpHeader = styled(InternalContainer)`
  margin-bottom: 18px;
`;

export const PageHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;

  @media (max-width: 575px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 18px;
  }
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: #343a40;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
`;

export const NewCampaignButton = styled.button`
  width: 151px;
  height: 40px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 25px;
  background: #0c50d3;
  color: #fbfbfb;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;

  &:hover,
  &:focus-visible {
    background: #0969f0;
    box-shadow: 0px 4px 8px 0px #33373c29;
  }

  &:active {
    background: #174a98;
    box-shadow: none;
  }

  @media (max-width: 575px) {
    width: 100%;
  }
`;

export const ContainerStyled = styled(Container)`
  margin: 0px;
  padding: 35px 28px 0px;
`;

export const StyledCol = styled(Col)`
  padding: 0px 8px !important;
`;

export const ButtonArrowStyled = styled.button`
  width: 140px;
  background: #4a90e2;
  border-radius: 0px 16px 16px 0;
  min-height: 32px;
  padding: 0 32px 0 26px;
  border: none;
  font-family: 'Gotham' !important;
  font-weight: 350;
  font-size: 14px;
  line-height: 32px;
  letter-spacing: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  z-index: 2;
`;

export const ArrowsStyled = styled.span`
  position: absolute;
  top: 11px;
  right: 17px;
  left: 120px;
  display: flex;
  align-items: center;
  height: 10px;
  gap: 0;
`;

export const FlexItem = styled.div`
  padding: 0 9px;

  &.col-3 {
    flex: 0 0 28%;
    max-width: 28%;
  }

  &.col-9 {
    flex: 0 0 72%;
    max-width: 72%;
  }

  &.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const NovadashStyled = styled.div`
  padding: 30px;
  font-family: 'Roboto Flex', sans-serif;

  * {
    font-family: 'Roboto Flex', sans-serif;
  }

  @media (max-width: 767px) {
    padding: 24px 16px;
  }

  .animate-width {
    transition: all 0.3s;
  }

  .animate-left {
    @keyframes fadein {
      0% {
        left: -100%;
      }
      100% {
        left: 0;
      }
    }

    animation: fadein 200ms;
  }
`;

export const ImageStyled = styled.img`
  width: 6px;
  height: 10px;
  opacity: 1;
`;
